import type { Page, PageNumber } from "@pdfking/renderer-api"
import { CreateCompletePage, CreateContext } from "@pdfking/renderer-api"
import { GuidToString, JSONHash, RecordMerge } from "@pdfking/tfunc"

import type { PdfEngineOptions } from "#public"
import type { PlottedPagePdf } from "#public"
import type { FilePlottingContext } from "#public"

import { PlotBoxes } from "../../internal/geometry/PlotBoxes"
import { VirtualFileType } from "../types/files/VirtualFileType"

// Packs a plotted page eagerly: geometry is derived synchronously from the page
// recipe (no file bytes needed), while the actual PDF is plotted lazily, like a
// merge, by the plan FilePlan builds from the recipe on RequestFile. Its guid
// is the page's own `page_id` when the caller gave one, so a context full of
// files isn't hashed per page; the recipe's hash otherwise.
export const CreatePlottedFile = (
  options: PdfEngineOptions,
  plot: Page,
  context: FilePlottingContext = {}
): PlottedPagePdf => {
  const page = CreateCompletePage(plot, CreateContext(RecordMerge(options, context)))

  return {
    ...PlotBoxes(page),
    context,
    enum: VirtualFileType.PLOTTED_PAGE_PDF,
    file_meta: {},
    guid: plot.page_id ?? GuidToString(JSONHash(plot, context)),
    page_count: 1 as PageNumber,
    page,
    page_number: 1 as PageNumber,
    // neutral label: merge/split relabel with the batch offset
    page_order: 0,
  }
}
